

import { updateCardByProductIdState, unselectAllProducts } from '@yggdrasil/Checkout/V2/CheckoutProductSelect/V2/checkoutProductSelect'
import { CF2Component, registerComponent } from 'javascript/lander/runtime'

export default class CheckoutV2 extends CF2Component {

constructor(el, runtimeSel) {
super(el, runtimeSel)
}



  mount() {
    const paymentGateway = typeof StripeCheckout === "function" ? "stripe" : "rebilly"
    const concreteCheckout = paymentGateway === "stripe"
      ? this.getComponent(StripeCheckout)
      : this.getComponent(RebillyCheckout)

    const checkoutLoading = this.getComponentGroup(CheckoutLoadingV1)

    // Use event delegation to handle multiple OTO buttons independently
    $(document).on('click', '[href="#submit-oto"]', async function(evt) {
      evt.preventDefault()
      evt.stopPropagation()
      
      const clickedButton = evt.currentTarget
      const element = clickedButton.closest<CF2Element>(`[data-page-element]`)
      const otoProductVariantPrice = element?.dataset?.selectedProduct
      const redirectOverride = element?.dataset?.otoRedirectOverride
      
      if (!otoProductVariantPrice) {
        console.error('No product selected for this OTO button')
        return
      }
      
      const [product_id, variant_id, price_id] = otoProductVariantPrice.split('-')
      
      unselectAllProducts()
      updateCardByProductIdState(product_id, { 
        variantId: variant_id, 
        priceId: price_id, 
        quantity: 1
      })

      const closestPaintColor = $(evt.target).closest('[data-paint-colors]').attr('data-paint-colors') ?? 'lightest'
      $('.id-checkout-modal-node-id').find('[data-page-element="Checkout/V2"]').attr('data-paint-colors', closestPaintColor)
      $('.id-checkout-modal-node-id').css('display', 'flex');
      checkoutLoading.show()
      $('.elCheckoutCTAHeader').hide();
      $('.elCheckoutBodyContainer').hide();

      function cartHasOnlySelectedVariant(cart, v2) {
        if(cart.items.length != 1 || cart.items[0].quantity != 1) {
            return false
        }
        const v1 = cart.items[0]

        return (v1.product_id == v2.product_id &&
          v1.variant_id == v2.variant_id &&
          v1.price_id == v2.price_id)
      }

      let shouldUnsubscribe = false
      let unsubscribe

      const showModal = () => {
        $('.elCheckoutCTAHeader').show()
        $('.elCheckoutBodyContainer').show()
        checkoutLoading.hide()
      }


      if (paymentGateway === "stripe") {
        concreteCheckout.checkout.preventOrderPreview = true
        await concreteCheckout.checkout.sendOrderPreview({skipThrottle: true, forceOrderPreview: true})
        const summary = globalThis.Checkout.store.summary.get()
        if (summary.state == globalThis.Checkout.SummaryStates.OK) {
          const cart = concreteCheckout.getCart()
          const ok = await concreteCheckout.submitOTO(redirectOverride)
          if (!ok) {
            concreteCheckout.checkout.preventOrderPreview = false
            showModal()
          }
        } else {
          concreteCheckout.checkout.preventOrderPreview = false
          showModal()
        }
      } else {
        unsubscribe = globalThis.Checkout.store.summary.subscribe(async (summary) => {
          if (summary.state == globalThis.Checkout.SummaryStates.OK) {
            shouldUnsubscribe = true
            const cart = concreteCheckout.getCart()
            if (!cartHasOnlySelectedVariant(cart, {product_id, variant_id, price_id})) {
              return
            }
            const ok = await concreteCheckout.submitOTO(redirectOverride)
            if (!ok) {
              showModal()
            }
          } else if (summary.state == globalThis.Checkout.SummaryStates.WAITING) {
            shouldUnsubscribe = true
            showModal()
          }
          if (shouldUnsubscribe) {
            unsubscribe && unsubscribe()
          }
        })
      }
      if (shouldUnsubscribe) {
        unsubscribe()
      }
    })
  }

  initializeStoreDependentElements(store, computed) {
    const checkoutElements = this.getAllComponents()
    const linkedElements = [...document.querySelectorAll(`[data-linked-checkout-id="${this.id}"]`)].map((el) => el.cf2_instance)
    const allElements = checkoutElements.concat(linkedElements)
    allElements.forEach((el) => {
      el?.initializeWithStore && el.initializeWithStore(store, computed)
    })
  }

  afterMount() {
    this.initializeStoreDependentElements(Checkout.store, Checkout.computed)

    const productVariantWithNoBump = globalThis.globalResourceData.productVariantWithNoBump
    if (productVariantWithNoBump) {
      const variantId = productVariantWithNoBump.id
      const productId = productVariantWithNoBump.product_id
      updateCardByProductIdState(productId, { variantId })
    }
  }



}

registerComponent('Checkout/V2', CheckoutV2)
window["CheckoutV2"] = CheckoutV2

